import { createFileRoute } from '@tanstack/react-router';
import { AdminFeedbackThreadScreen } from '@/features/admin/AdminFeedbackThreadScreen';

export const Route = createFileRoute('/_app/admin/feedback/$feedbackId')({
  component: () => {
    const { feedbackId } = Route.useParams();
    return <AdminFeedbackThreadScreen feedbackId={Number(feedbackId)} />;
  },
});
